import { Button, Grid } from '@mui/material';
import CardFilterDTO from '@src/adapters/dto/card/CardFilterDTO';
import ControlledConsultantAutoComplete from '@src/components/consultant/ControlledConsutlantAutoComplete';
import ControlledDropdown from '@src/components/ControlledDropdown';
import { DropdownOption } from '@src/components/DropDown';
import ControlledProcedureAutoComplete from '@src/components/procedure/ControlledProcedureAutoComplete';
import ControlledSpecialityAutoComplete from '@src/components/speciality/ControlledSpecialityAutoComplete';
import { CardStatus } from '@src/constants/CardStatus';
import { useFormContext } from 'react-hook-form';

const cardStatusOptions: DropdownOption[] = Object.values(CardStatus).map(
  (status) => ({
    id: status,
    name: status,
  })
);

function Filters() {
  const { setValue } = useFormContext<CardFilterDTO>();

  const onClear = () => {
    setValue('consultantId', undefined);
    setValue('specialityId', undefined);
    setValue('procedureId', undefined);
  };

  return (
    <Grid
      container
      sx={(theme) => ({
        padding: theme.spacing(2),
        spacing: theme.spacing(2),
      })}
      spacing={2}>
      <Grid item xs={3}>
        <ControlledDropdown
          options={cardStatusOptions}
          label="Statuses"
          fieldName="statuses"
          multiple={true}
        />
      </Grid>
      <Grid item xs={3}>
        <ControlledConsultantAutoComplete fieldName="consultantId" />
      </Grid>
      <Grid item xs={2}>
        <ControlledSpecialityAutoComplete fieldName="specialityId" />
      </Grid>
      <Grid item xs={2}>
        <ControlledProcedureAutoComplete fieldName="procedureId" />
      </Grid>
      <Grid item xs={2}>
        <Button
          variant="outlined"
          onClick={() => onClear()}
          sx={{ minHeight: '48px' }}>
          Clear Filters
        </Button>
      </Grid>
    </Grid>
  );
}

export default Filters;
